var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nx-dialog',{attrs:{"visible":_vm.show,"title":"删除机械备案信息","width":"600px","before-close":_vm.beforeClose},on:{"update:visible":function($event){_vm.show=$event},"onConfirm":_vm.onConfirm}},[_c('nx-form',{ref:"submitForm",attrs:{"source":_vm.submitForm,"config":_vm.submitConfig}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }